import { RootState } from '@/store'

export const getAuditConnector = (state: RootState) => {
  return state.organizationAuditConnectorPage.auditConnectors.length > 0
    ? state.organizationAuditConnectorPage.auditConnectors[0]
    : null
}
